import {
    AfterViewInit, Component, ElementRef, EventEmitter,
    Input, OnChanges, Output, SimpleChanges, ViewChild
} from '@angular/core';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { CalendarDataService } from './calendar.data.service';
import { CalendarSlideService } from './calendar.slide.service';
import { CalendarEventService } from './calendar.event.service';

import { TransformTimePipe } from '../../../shared/pipe/time/pipe.time';
import { ITextSlider } from '../../molecules/text.slider/text.slider.interface';
import { WindowRefService } from '../../../shared/service/window/window.service';
import { ICalendar, ICalendarAddSlot, ICalendarDates } from './calendar.interface';
import { ISlot } from '../../molecules/slot/slot.component.interface';
import { ISlotEvent } from './slot-event.interface';
import { IPitch } from '../../../shared/model/pitch.interface';
import { SlotService } from '../../molecules/slot/slot.service';

export const TIMEZONE = 'Europe/London';

@Component({
    selector: 'mlp-ng-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    providers: [
        WindowRefService,
        CalendarDataService,
        CalendarSlideService,
        CalendarEventService,
        TransformTimePipe
    ]
})

export class CalendarSharedComponent implements AfterViewInit, OnChanges {
    @Input() calendar: ICalendar;
    @Input() pitch: IPitch;
    @Input() textDate: ITextSlider;
    @Input() loading: boolean;
    @ViewChild('drag') drag: ElementRef;
    @Output() dateRange = new EventEmitter<ICalendarDates>();
    @Output() date = new EventEmitter<ICalendarAddSlot>();
    @Output() slotEvent: EventEmitter<ISlotEvent> = new EventEmitter();
    meridiem = this.calDataService.meridiem;
    arrows = {
        left: false,
        right: true
    };
    dateForDatepicker = new EventEmitter<string>();

    constructor(
        public calDataService: CalendarDataService,
        public calSlideService: CalendarSlideService,
        public calEventService: CalendarEventService,
        public slotService: SlotService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        const cal = changes['calendar'];
        if (cal && !cal.firstChange) {
            const resetCalendar = (this.calendar.reload) ? this.calendar.reload : false;
            this.calSlideService.indexForNoon = 0;
            this.calDataService.getIndexForTimes(this.calendar.timeRange);
            this.calSlideService.resetCalendar(resetCalendar, this.calendar.columns);
        }
    }

    ngAfterViewInit(): void {
        this.calDataService.getIndexForTimes(this.calendar.timeRange);
        this.calSlideService.setDrag(this.drag, this.calendar.columns);
        this.calSlideService.setClick();
        setTimeout(_ => {
            this.calSlideService.arrows$.subscribe(arrows => this.arrows = arrows);
            this.calSlideService.meridiem$.subscribe(meridiem => this.meridiem = meridiem);
        }, 0);
    }

    meridiemChange(data): void {
        this.calSlideService.meridiemChange(data);
    }

    sendNewDateData(direction: string): void {
        const newDate = this.calEventService.updateDates(direction, this.calendar.startDate);
        this.dateForDatepicker.emit(newDate.startDate);
        this.dateRange.emit(this.calEventService.updateDates(direction, this.calendar.startDate));
    }

    sendNewDateDataFromDatepicker(newDate: string): void {
        this.dateRange.emit(this.calEventService.updateDates('fromDatepicker', newDate));
    }

    sendDay(date: NgbDateStruct, index: number): void {
        this.date.emit({ date, index });
    }

    sendSlotEvent(slot, index, row, type): void {
        this.slotEvent.emit({slot, index, row, type});
    }
}
